import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../layout/use-page-title.js';

/**
 * Light terms & conditions page for the prerelease service.
 * @returns {JSX.Element}
 */
export function TermsPage() {
	const { t } = useTranslation();
	usePageTitle('site.terms.title', 'site.meta.terms.description');

	return (
		<section className="terms">
			<h1>{t('site.terms.title')}</h1>
			<p className="terms-lede">{t('site.terms.lede')}</p>
			<div className="terms-body">
				<p>{t('site.terms.secure')}</p>
				<p>{t('site.terms.data')}</p>
				<p>{t('site.terms.notRecommended')}</p>
				<p>{t('site.terms.end')}</p>
			</div>
			<p className="terms-risk">{t('site.terms.risk')}</p>
			<p className="terms-governing">{t('site.terms.governingNote')}</p>
		</section>
	);
}
